<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select v-model="query.companyId" placeholder="公司" clearable  class="handle-select mr10">
					<el-option v-for="item in companys" :label="item.companyName" :value="item.companyNo"></el-option>
				</el-select>
				<el-input v-model="query.name" style="width: 150px;" placeholder="用户名称" clearable  class="handle-input mr10"></el-input>
				<el-checkbox v-model="query.isOpen" class="mr10">公共角色</el-checkbox>
				<el-button type="primary" icon="el-icon-search" @click="clickSearch">搜索</el-button>

			</div>
			<el-table :data="tableData" border>
				<el-table-column prop="companyName" label="所属公司"></el-table-column>
				<el-table-column prop="roleName" label="角色名称"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button title="选择" plain @click="infoClick(scope.$index)">选择</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageRows"
				 :total="pageTotal" @current-change="handlePageChange" prev-click="pageChange(1)" next-click="pageChange(2)"></el-pagination>
			</div>

		</div>



	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data: function() {
			return {
				query: {
					status: '',
					name: '',
					pageIndex: 1,
					pageRows: 10
				},
				tableData: [],
				pageTotal: 0,

			}
		},
		computed:{
			...mapState(['companys']),
		},
		created() {
			this.handleSearch()
		},
		methods: {
			clickSearch: function() {
				this.query.pageIndex = 1;
				this.handleSearch();
			},
			handleSearch: function() {
				//查询
				this.HTTP.post('/system/role/queryPage', this.query).then(res => {

					if (res.data.code == 1) {
						this.tableData = res.data.rows
						this.pageTotal = res.data.counts
					}else{
						this.$message.error(res.data.message);
					}

				}).catch(err => {
					console.log(err)
				})
			},
			handlePageChange: function(e) {
				this.query.pageIndex = e
				this.handleSearch()
			},
			pageChange: function(type) {
				if (type == 1) {
					this.query.pageIndex -= 1;
				} else {
					this.query.pageIndex += 1;
				}

				this.handleSearch()
			},
			infoClick: function(i) {
				this.$emit('choose', this.tableData[i])
			}


		}
	}
</script>

<style>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.info-div {
		display: flex;
		justify-content: space-around;
		margin-top: 5px;
		font-size: 13px;
	}

	.info-span1 {
		width: 230px;
		font-size: 15px;
	}

	.info-span2 {
		width: 230px;
		font-size: 15px;
	}

	.info-title {
		margin-right: 4px;
		color: #000000;
	}
</style>
